if (!customElements.get("announcement-bar-slider")) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();
      const options = JSON.parse(this.getAttribute("data-swiper-options")) || {};
      this.slider = null;
      this.ensureSlider(options);
      window.addEventListener("shopify:section:load", () => {
        this.ensureSlider(options);
      });
    }

    ensureSlider(options) {
      const mount = () => {
        if (this.slider) {
          return;
        }
        this.slider = new Swiper(this, {
          slidesPerView: 1,
          loop: options.loop || false,
          allowTouchMove: false,
          autoplay: options.autoplay || false
        });
      };
      const loader = window.themeLibraryLoader;
      if (loader && typeof loader.whenSwiperReady === "function") {
        loader.whenSwiperReady(mount);
      } else if (window.Swiper) {
        mount();
      }
    }
  }

  customElements.define("announcement-bar-slider", AnnouncementBarSlider);
}
